export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M17 50V29a15 15 0 0 1 30 0v21" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
    <circle cx="32" cy="33" r="6" fill="#F2C9B5" stroke="currentColor" strokeWidth="1.8" />
    <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <path d="M32 21v3" />
      <path d="M23.5 25l2.1 2.1" />
      <path d="M40.5 25l-2.1 2.1" />
      <path d="M20 33h3" />
      <path d="M41 33h3" />
    </g>
    <path d="M12 50h40" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark className={`h-9 w-9 ${light ? "text-gold-light" : "text-gold"}`} />
    <span className="leading-none">
      <span className={`block font-serif text-lg sm:text-xl font-semibold tracking-wide ${light ? "text-cream" : "text-ink"}`}>Glow Motion</span>
      <span className={`block text-[10px] uppercase tracking-[0.42em] ${light ? "text-gold-light" : "text-gold-dark"}`}>Pictures</span>
    </span>
  </span>
);
